import BaseComponent from './BaseComponent';
import Plyr from 'plyr';             // https://github.com/sampotts/plyr


class Video extends BaseComponent {
  constructor(componentName, withControls = false) {
    super(componentName);
    this.options = {
      controls: [],
      muted: true,
      // // controls: ['large-play', 'play', 'fullscreen', 'airplay', 'current-time', 'pip'],
      autoplay: true,
      loop: {
        active: true
      }
    };

    this.classElement = `.${componentName}`;
  }


  init(component) {
    component.player = new Plyr(`#${component.id}`, this.options);
    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    component.element.addEventListener('ready', e => {
      this.autoplayVideo(component);
    })
  }


  autoplayVideo(video) {
    setTimeout(() => {
      video.player.volume = 0;

      if(!!video.player.play) {
        const play = video.player.play();

        if (play !== undefined) {
          play.then(_ => {
            // Autoplay started!
          }).catch(error => {
            // Autoplay was prevented.
            console.warn('autoplay prevented');
            // Show a "Play" button so that user can start playback.
          });
        }
      }
    }, 100);
  }
}

export default Video;
